let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iHPxa")).then(() => parcelRequire('4M9Uw'));